import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import { useTranslation } from "../hooks/useTranslation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = () => {
  const [{ name, email, message }, setState] = useState(initialState);
  const { translate } = useTranslation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);

    emailjs
      .sendForm("service_r17oruc", "template_vone3bl", e.target, "JIh1TvRHadWPsdL8n")
      .then(
        (result) => {
           toast.success(translate("sendingSuccess"));
          clearState();
        },
        (error) => {
           toast.success(translate("sendingError"));
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
        <div className="col-md-4"></div>
          <div className="col-md-8">
            <div className="row">
              <div className="section-title-test" style={{textAlign:"right"}}>
                <h2>{translate("contact_title")}</h2>
                <p>{translate("contact_description")}</p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder={translate("placeholder_name")}
                        required
                        value={name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        value={email}
                        placeholder={translate("placeholder_email")}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={translate("placeholder_message")}
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div id="success"></div>
                <div style={{textAlign:"right"}}>
                <button type="submit" className="btn btn-custom btn-lg">
                  {translate("send_message")}
                </button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={translate('contact_instagram')} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={translate('contact_twitter')} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={translate('contact_whatsapp')} target="_blank" rel="noopener noreferrer">
                      <i className="fa fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 Fourpus
          </p>
        </div>
      </div>
    </div>
  );
};


/*
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{translate("contact_info")}</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> {translate("address")}
                </span>
                {translate('contact_address')}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> {translate("phone")}
                </span>{" "}
                {translate('contact_phone')}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> {translate("email")}
                </span>{" "}
                {translate('contact_email')}
              </p>
            </div>
          </div>

*/